import { useState, useEffect } from "react";
import { v4 as uuidv4 } from 'uuid';

export const WS_MESSAGE_TYPE_EXECUTING="executing"

//prompt received
export const WS_MESSAGE_TYPE_EXECUTED="executed"

//queue status, remaining
export const WS_MESSAGE_TYPE_STATUS="status"

// value: current progress, max: total
export const WS_MESSAGE_TYPE_PROGRESS="progress"

// prompt is sent
export const WS_MESSAGE_TYPE_EXECUTION_START="execution_start"
export const WS_MESSAGE_TYPE_EXECUTION_CACHED="execution_cached"

// generation finished
export const WS_MESSAGE_TYPE_EXECUTION_SUCCESS="execution_success"


export const loadWorkflow = async () => {
    try {
        const response = await fetch(process.env.PUBLIC_URL +`/workflow.json`);
        WORKFLOW = await response.json();
        //console.log("Workflow Loaded:", WORKFLOW);
        console.log("Workflow Loaded!");
    } catch (error) {
        console.error("Error loading workflow:", error);
    }
};

export interface DashboardGenParams {
    cfg: number
    steps: number
    cnetEdges: number
    cnetVolume: number
    seed: number
    checkpoint: string
    height: number
    width: number
    positivePrompt: string
    negativePrompt: string

    checkedColors: { cyan: boolean; blue: boolean; lime: boolean; green: boolean; red: boolean; vegetation: boolean; };

    cyanPrompt: string 
    cyanNegative: string
    cyanReference: string 
    cyanPromptWeight: number
    cyanNegativeWeight: number
    cyanImgWeight: number
    
    bluePrompt: string 
    blueNegative: string
    blueReference: string 
    bluePromptWeight: number
    blueNegativeWeight: number
    blueImgWeight: number

    limePrompt: string 
    limeNegative: string
    limeReference: string 
    limePromptWeight: number
    limeNegativeWeight: number
    limeImgWeight: number

    greenPrompt: string 
    greenNegative: string
    greenReference: string 
    greenPromptWeight: number
    greenNegativeWeight: number
    greenImgWeight: number

    redPrompt: string 
    redNegative: string
    redReference: string 
    redPromptWeight: number
    redNegativeWeight: number
    redImgWeight: number

    vegetationPrompt: string 
    vegetationNegative: string
    vegetationReference: string 
    vegetationPromptWeight: number
    vegetationNegativeWeight: number
    vegetationImgWeight: number


    inImage: string 
    atmospherePrompt: string
    stylePrompt: string
    style: string
    upscaler: boolean



}

export interface Root {
    CheckpointLoaderSimple: CheckpointLoaderSimple
}

export interface Input {
    required: Required
}

export interface Required {
    ckpt_name: string[][]
}

export interface CheckpointLoaderSimple {
    input: Input
    output: string[]
    output_is_list: boolean[]
    output_name: string[]
    name: string
    display_name: string
    description: string
    category: string
    output_node: boolean
}


export let WORKFLOW: any = {}; 